<div class="notice-block">
  <h4>About real-time replication...</h4>
  <ol *ngIf="isAws">
    <li>
      Real-time replication works for DynamoDB Tables, EC2 instances, S3 buckets, and RDS DB Clusters. Other resources
      will be replicated via frequent snapshots.
    </li>
    <li>
      Real-time replication will utilize additional resources in your recovery environment. Your AWS bill will be
      higher.
    </li>
    <li>
      For more information, you can check out the
      <a [href]="rtReplicationDocsUrl | safeUrl" target="_blank"> documentation for real time replication</a>.
    </li>
  </ol>
  <ol *ngIf="isAzure">
    <li>
      Real-time replication works for Azure Blob Storage and Azure SQL. Other resources will be replicated via frequent
      snapshots.
    </li>
    <li>
      Real-time replication will utilize additional resources in your recovery environment. Your Azure bill will be
      higher.
    </li>
    <li>
      For more information, you can check out the
      <a [href]="rtReplicationDocsUrl | safeUrl" target="_blank"> documentation for real time replication</a>.
    </li>
  </ol>
</div>
